import { Api, LocalDictionaryFactory } from  './../../api/api.module'
import { EventsNames } from '../../../helpers/events-names'
import { CommonHelper } from '../../../helpers/common-helper'
import { i18n } from '../../common/i18n/common.i18n'
import { PopupType } from './../../../helpers/popup-manager'
import { CreateEditController, CreateEditScope } from '../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../common/create-edit-popup/create-edit-popup.controller'
import { IUserSession } from '../../../helpers/user-session'

import { Enums } from '../../../models/common/enums'
import { IOpObject } from '../../../models/util/interfaces'
import { OpSimCard } from '../../../models/core/op-sim-card'

import { SESSION } from '../../../models/custom/session'

interface SimcardCreateEditScope extends CreateEditScope {
}

export class SimcardsCreateEditController extends CreateEditController
{
    private referenceValue: OpSimCard

    constructor(private $scope: SimcardCreateEditScope, private $q: ng.IQService, private $timeout: ng.ITimeoutService,
        private api: Api, private localDictionary: LocalDictionaryFactory, protected userSession: IUserSession) {
        super(Enums.ReferenceType.IdSimCard)

        this.setEvents()
        this.setOptions()
    }

    onInit(args: any[]) {
        if (args && args[0]) {
            var createEditInitParams: CreateEditInitParams = args[0]
            this.referenceValue = createEditInitParams ? <OpSimCard><any>createEditInitParams.referenceObject : null
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)
            this.$scope.popupType = PopupType.CREATE_EDIT_POPUP
            if (this.referenceValue && this.referenceValue.idObject > 0) {
                this.$scope.options.title = i18n('Popup', 'SimcardEdit')
            } else {
                this.$scope.options.title = i18n('Popup', 'SimcardAdd')
            }
            //Zapewnienie żeby najpierw wywołał się SHOW_CREATE_EDIT_POPUP a dopiero potem OPEN_CREATE_EDIT_POPUP
            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams)
            })
        }
    }
    onInitBulk(args: any[]) {
        if (args && args[0]) {
            var bulkEditInitParams: BulkEditInitParams = args[0]
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = i18n("Popup", "SimCardBulkEdit")
            this.$scope.popupType = PopupType.BULK_EDIT_POPUP

            if (args && args[0]) {
                this.$scope.gridData = args[0]
            }

            if (args && args[1]) {
                this.$scope.gridColumns = args[1]
            }
            
            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        } 
    }

    onSave(objectToSave: IOpObject): ng.IPromise<IOpObject>  {
        var simCardToSave: OpSimCard = OpSimCard.fromIOpObject(objectToSave)
        var defferer = this.$q.defer<IOpObject>()
        this.userSession.getDataProvider().SimCard.saveSimCard(simCardToSave).then((savedObject: OpSimCard) => {
            if (savedObject) {
                CommonHelper.openInfoPopup(i18n('Popup', 'SimcardSaved'))
                CommonHelper.setValueToLocalStorage('simcardSaved', true, 0)
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)
            }
            else {
                CommonHelper.openInfoPopup(i18n('Popup', 'SimcardSaveError'), 'error', 5000)
            }
            defferer.resolve(savedObject)
        }).fail(err => {
            var errorMsg: string = err
            if (SESSION.isType(err))
                errorMsg = (<SESSION>err).toString()
            console.log(errorMsg)
            CommonHelper.openInfoPopup(errorMsg, 'error', 5000)
            defferer.reject()
        })
        return defferer.promise
    }
    onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        var simCardToSave: OpSimCard = OpSimCard.fromIOpObject(objectToSave)
        var defferer = this.$q.defer<IOpObject>()
        this.userSession.getDataProvider().SimCard.saveSimCard(simCardToSave).then(savedObject => {
            defferer.resolve(savedObject)
        }).fail(err => {
            var errorMsg: string = err
            if (SESSION.isType(err))
                errorMsg = (<SESSION>err).toString()
            defferer.reject(errorMsg)
        })
        return defferer.promise
    }

    setEvents() {
        this.$scope.$on(EventsNames.SIM_CARD_OPEN_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => { this.onInit(args) })
        this.$scope.$on(EventsNames.SIM_CARD_OPEN_BULK_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => { this.onInitBulk(args) })
    }
    setOptions() {
        this.$scope.popupVisible = false
        this.$scope.options = {
            title: "",
            type: PopupType.SIM_CARD_POPUP,//NIE UŻYWAĆ!!!
            referenceType: this.referenceType,
            onSave: (objectToSave: IOpObject) => { return this.onSave(objectToSave) },
            onBulkSave: (objectToSave: IOpObject) => { return this.onBulkSave(objectToSave) },
            onSubmit: null,//DO USUNIECIA!!!
            onClose: null,
            submitBulkEdit: null,//DO USUNIECIA!!!
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.simcardSaved,//Żeby się poprawnie odświeżył grid w module kart sim
            succsessMessage: i18n('Popup', 'SimcardSaved')
        }
    }
}